import RequestService from './request-service';

/**
 * Class for handling activespecial bet combinations
 */
export default class SpecialBetCombinations extends RequestService {
  constructor() {
    super();
    this.method = 'get';
    this.endpoint = this.$config.endpoints.getActiveSpecialBetTypeCombinations;
  }
}